import { forwardRef } from 'react';

import { Search, X } from 'lucide-react';

import Button from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const SearchInput = forwardRef(
  ({ inputClass, className = '', ...props }, ref) => {
    return (
      <div className={`relative ${className}`}>
        <div className="absolute top-1/2 left-4 transform -translate-y-1/2">
          <Search size={24} />
        </div>
        <Input
          ref={ref}
          className={`pl-14 ${inputClass}`}
          placeholder="Center, city, or country"
          {...props}
        />
        {props.value && (
          <div className="absolute top-1/2 right-4 transform -translate-y-1/2">
            <Button
              variant="icon"
              className="h-10 w-10 p-0"
              onClick={() =>
                props.onChange({
                  target: { name: 'search', value: '' },
                })
              }
            >
              <X size={24} />
            </Button>
          </div>
        )}
      </div>
    );
  }
);
SearchInput.displayName = 'SearchInput';

export default SearchInput;
